export default "__VITE_PUBLIC_ASSET__df0ba721__"